module.exports = __webpack_public_path__ + "img/icon-done-blue.1b9a5804.svg";